Namespace 'Customer.Filters.EditCustomAttributes'

class Customer.Filters.EditCustomAttributes.EditFixedStringView extends Backbone.View
  className: 'filter-field-container filter-custom-attribute-container'

  initialize: ({customAttribute, filter, editable}) ->
    @customAttribute = customAttribute
    @filter = filter
    @editable = editable
    @selectView = @_selectView()

  render: ->
    @$el.append(@selectView.el)
    @listenTo(@selectView, 'change', -> Backbone.trigger 'customerSession:keepAlive')
    @

  getValuesForFilter: =>
    code: @customAttribute.code
    values: @selectView.toArray()

  _getCurrentTags: ->
    _.find(@filter.get('query').custom_attributes.tags, (attribute) =>
      attribute.code == @customAttribute.code
    )?.values

  _selectView: ->
    new Customer.Filters.SelectView(
      title: @customAttribute.name
      options: @customAttribute.tags
      valueProperty: 'name'
      descriptionProperty: 'name'
      selectedOptions: @_getCurrentTags()
      placeholder: @customAttribute.name
      editable: @editable
    )
